import { useState } from 'react';
import styled from 'styled-components';

import ContainerLogin from 'shared/components/adminPassword/ContainerLogin';
import Upload from 'shared/components/commonComponentsMC/UploadBox';


const SitePlanUpload = ({ swtName, locationId, locationData }) => {
  const [displayPassword, setDisplayPassword] = useState(false);
  const [displayUpload, setDisplayUpload] = useState(false);
  const [displayViewer, setDisplayViewer] = useState(false);

  const sitePlanUrl = locationData?.[`site_maps_${swtName.toUpperCase()}`] || '';

  return (
    <Actions>
      {sitePlanUrl && (
        <PlanButton type="button" onClick={() => setDisplayViewer(true)}>
          View plans
        </PlanButton>
      )}
      <PlanButton type="button" onClick={() => setDisplayPassword(true)}>
        Upload site plan
      </PlanButton>

      {displayPassword && (
        <Overlay onClick={() => setDisplayPassword(false)}>
          <ContainerLogin
            handleClose={() => setDisplayPassword(false)}
            handleDisplayUploadSitePlan={() => setDisplayUpload(true)}
          />
        </Overlay>
      )}

      {displayUpload && (
        <Overlay onClick={() => setDisplayUpload(false)}>
          <UploadAnchor onClick={(e) => e.stopPropagation()}>
            <Upload
              handleClose={() => setDisplayUpload(false)}
              locationId={locationId}
              specificLocationId=""
              swtName={swtName}
            />
          </UploadAnchor>
        </Overlay>
      )}

      {displayViewer && sitePlanUrl && (
        <Overlay onClick={() => setDisplayViewer(false)}>
          <ViewerBox onClick={(e) => e.stopPropagation()}>
            <ViewerClose type="button" onClick={() => setDisplayViewer(false)}>
              X
            </ViewerClose>
            <embed src={sitePlanUrl} type="application/pdf" />
          </ViewerBox>
        </Overlay>
      )}
    </Actions>
  );
};

export default SitePlanUpload;



const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

const PlanButton = styled.button`
  padding: 8px 16px;
  border: 0.8px solid var(--switch-blue-border);
  border-radius: 8px;
  background: var(--switch-blue-soft);
  color: #60a5fa;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;

  &:hover {
    background: var(--switch-blue-subtle);
    transform: translateY(-1px);
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
`;

const UploadAnchor = styled.div`
  position: relative;
  width: 207px;
  min-height: 220px;
`;

const ViewerBox = styled.div`
  position: relative;
  width: 70vw;
  height: 80vh;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);

  embed {
    width: 100%;
    height: 100%;
  }
`;

const ViewerClose = styled.button`
  position: absolute;
  top: 10px;
  right: 14px;
  z-index: 1;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 16px;
  background: #323639;
`;
